<template>
  <div class="button-group" :class="{ 'button-group--centered': isCentered }">
    <button
      class="btn btn-secondary"
      :class="{ 'btn--left': isCentered }"
      @click="$emit('back')"
      v-if="backButtonIsVisible"
    >
      返回
    </button>
    <button
      class="btn btn-primary"
      :class="{ 'btn--right': !isCentered }"
      :disabled="!canProceed"
      :style="!canProceed ? { opacity: '0.6', cursor: 'not-allowed' } : {}"
      @click="$emit('next')"
      v-if="nextButtonIsVisible"
    >
      {{ textForNextStep }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TongxinNavigation',
  props: {
    canProceed: {
      type: Boolean,
      default: false,
    },
    backButtonIsVisible: {
      type: Boolean,
      default: true,
    },
    nextButtonIsVisible: {
      type: Boolean,
      default: true,
    },
    textForNextStep: {
      type: String,
      default: '下一步',
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  &--centered {
    justify-content: center;
  }

  .btn {
    flex: 1;

    &--left {
      margin-right: auto;
    }

    &--right {
      margin-left: auto;
    }
  }
}
</style>
